'use client';
import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { HEADER_CONFIG } from '@eliadmin/core/src/constants/header-config';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import React from 'react';

interface CustomHeaderProps {
  className?: { wrapper?: string; button?: string; link?: string; icon?: string };
  showText?: boolean;
}

export function CustomHeader(props: CustomHeaderProps) {
  const generalLayout = useGlobalStore(s => s.generalLayout);

  return (
    <div
      className={cn(
        'flex flex-col items-start justify-start gap-3',
        'ea-header-icons__wrapper',
        props.className?.wrapper,
      )}
    >
      <p className={cn('hidden text-sm font-bold md:block', props.showText ? 'block' : 'hidden')}>
        Spoj sa s TFS
      </p>
      <div className={cn('flex flex-row flex-wrap gap-2', 'ea-social-icons__wrapper')}>
        {!!generalLayout.social_media &&
          Object.entries(generalLayout.social_media)
            .filter(([_, value]) => !!value)
            .map(([key, value]) => {
              return (
                <Button
                  key={key}
                  asChild
                  aria-label={`Social media link ${key}`}
                  size="icon"
                  className={cn(
                    'flex items-center justify-center rounded-full',
                    'ea-social-icons__button bg-[#FF3339] hover:bg-[#FF3339]',
                    props.className?.button,
                  )}
                >
                  <a
                    href={value}
                    aria-label={`Social media link ${key}`}
                    target="_blank"
                    rel="noreferrer"
                    className={cn(
                      'bg-[#FF3339]',
                      'ea-social-icons__icon-link',
                      props.className?.link,
                    )}
                  >
                    {React.cloneElement(
                      HEADER_CONFIG.socialMediaIcons[
                        key as keyof GeneralLayout['data']['social_media']
                      ],
                      {
                        className: cn(
                          'size-6 fill-white',
                          'ea-social-icons__icon',
                          props.className?.icon,
                        ),
                      },
                    )}
                  </a>
                </Button>
              );
            })}
      </div>
    </div>
  );
}
